import { PermissionsBaseModel } from '@fluxonos/features/user/models/permissions-base.model';
import { EnergySupplierPermissionsEnum } from '@fluxonos/fluxonos-dto';

export class PermissionsEnergySupplierModel extends PermissionsBaseModel {
  public get canView(): boolean {
    const permissions = [EnergySupplierPermissionsEnum.VIEW__FLUXONOS__ENERGY_SUPPLIER];
    return this.checkPermissions(permissions);
  }

  public get canChange(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [EnergySupplierPermissionsEnum.CHANGE__FLUXONOS__ENERGY_SUPPLIER];
    return this.checkPermissions(permissions);
  }

  public get canAdd(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [EnergySupplierPermissionsEnum.ADD__FLUXONOS__ENERGY_SUPPLIER];
    return this.checkPermissions(permissions);
  }

  public get canDelete(): boolean {
    if (!this.canView) {
      return false;
    }
    const permissions = [EnergySupplierPermissionsEnum.DELETE__FLUXONOS__ENERGY_SUPPLIER];
    return this.checkPermissions(permissions);
  }

  public get isAdmin(): boolean {
    return this.canView && this.canChange && this.canAdd && this.canDelete;
  }
}
